module.exports = __webpack_public_path__ + "static/img/us.56a72df.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutus/us.png
// module id = oXRQ
// module chunks = 0